export enum NumeroriRasa {
  Emerore = 10,
  Gjinore = 11,
  Dhanore = 12,
  Kallezore = 13,
  Rrjedhore = 14,
}

export enum NumeroriShoqerimi {
  Ishoqeruarmeemer = 10,
  Ipashoqeruarmeemer = 11,
}

export enum NumeroriGjinia {
  Mashkullore = 10,
  Femerore = 11,
}

export enum NumeroriLloji {
  Imirefillte = 10,
  Teresor = 11,
}

export enum NumeroriKategoria {
  njee = 10,
  dy = 11,
  tre = 12,
  kateer = 21,
  gjashtee = 13,
  njeezet = 14,
  njeezetenjee = 15,
  njeezetedy = 16,
  njeezetetre = 17,
  njeezetekateer = 22,
  njeezetegjashtee = 18,
  Thyesatmenumeeruesnjee = 19,
  Thyesatmenumeeruesdyesipeer = 20,
}
